import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-anlegen-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerAnlegenAdminEffects {

    BenutzerAnlegenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_ANLEGEN_ADMIN),
        mergeMap((x: ac.PostBenutzerAnlegenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerAnlegenAdmin(x.benutzerAnlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerAnlegenAdminErfolgreichAction(result, x.benutzerAnlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerAnlegenAdminFehlerAction(error, x.benutzerAnlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
